import { BASE_URL } from "config";

import * as base from './_base';


export const endpoints = {
    list: `${BASE_URL}/api/v1/seo/`,
    detail: (id) => `${BASE_URL}/api/v1/seo/${id}/`,
};

export const pageListLoad = (token, payload) => base.ListLoad(endpoints.list, token, payload);
export const pageDetailLoad = (token, { id }) => base.DetailLoad(endpoints.detail, token, { id });
export const pageUpdate = (token, data) => base.Update(endpoints.list, endpoints.detail, token, data);
export const pageDelete = (token, data) => base.Delete(endpoints.detail, token, data);
